// This file is used for maintain and manage API services.
(function() {
  'use strict';
  angular.module('obex').
  factory('traveler', ['$http', 'obexConstant', 'authService', '$q',
    ($http, obexConstant, authService, $q) => {
		let showAll = false;
    let currentRequestCanceler = null;
      return {

		    setShowAll(showAllTravelers) {
          showAll =  showAllTravelers;
        },
        getShowAll() {
          return showAll;
        },

        getTravelerById(id) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlAccount}/${id}`;
            return $http.get(url, {
              headers: authHeader,
            });
          });
        },
        getTravelersByOrgId(orgId, paginationData, showAllTraveler, searchKeyword) {
          if (currentRequestCanceler) {
            currentRequestCanceler.resolve();
          }
          currentRequestCanceler = $q.defer();
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlTravelers}/${orgId}/page/${paginationData.paginationCurrentPage ? paginationData.paginationCurrentPage : 1}/pagesize/${paginationData.paginationPageSize}/columnname/FirstName/ordertype/asc/searchphrase/${searchKeyword === '' ? ' ' : searchKeyword}/includeinactive/${showAllTraveler}`
            return $http.get(url, {
              headers: authHeader,
              timeout: currentRequestCanceler ? currentRequestCanceler.promise : 0
            }).finally(() => {
              currentRequestCanceler = null;
            }).catch(error => {
              if (error.status === -1) {
                console.log('Request canceled');
              } else {
                console.error('API call error:', error);
                throw error;
              }
            });
          });
        },
        deleteAccount(id) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlAccount}/${id}`;
            return $http.delete(url, {
              headers: authHeader,
            });
          });
        },
        setAdmin(id, isAdmin) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlAccount}/setadmin/${id}/${isAdmin}`;
            return $http.put(url, null, {
              headers: authHeader,
            });
          });
        },
        setEnableDisableAccount(id, enable) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlAccount}/enableAccount/${id}`;
            return $http.put(url, null, {
              headers: authHeader,
            });
          });
        },
        updateName(id, traveler) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlAccount}/updatename/${id}`;
            const putData = {
              Id: traveler.Id,
              FirstName: traveler.FirstName,
              LastName: traveler.LastName,
            };
            return $http.put(url, putData, {
              headers: authHeader,
            });
          });
        },
        saveTraveler(traveler) {
          return authService.getAuthorizationHeader().then(authHeader => {
            const url = `${obexConstant.urlAccount}`;
            return $http.post(url, traveler, {
              headers: authHeader,
            });
          });
        },
        sendNonSsoInfo(file, data) {
          return authService.getAuthorizationHeader().then(({Authorization}) => {
          let fd = new FormData();
          fd.append('image', file);
          fd.append('organizationId', data.organizationId);
          fd.append('password', data.password);
          fd.append('additionalEmail', data.additionalEmail);
          fd.append('userEmail',data.userEmail);
          fd.append('orgName', data.orgName);
          $http.post('/userUploadingForNonSso', fd, {
            headers: {
              'Content-Type': undefined,
              Authorization
            },
            transformRequest: angular.identity,
          });
        })
        },
        sendSsoInfo(file, data) {
          return authService.getAuthorizationHeader().then(({Authorization}) => {
          let fd = new FormData();
          fd.append('image', file);
          fd.append('organizationId', data.organizationId);
          fd.append('additionalEmail', data.additionalEmail);
          fd.append('userEmail',data.userEmail);
          fd.append('orgName', data.orgName);
          $http.post('/userUploadingForSso', fd, {
            headers: {
              'Content-Type': undefined,
              Authorization
            },
            transformRequest: angular.identity,
          });
        })
        }
      };
    },
  ]);
})();


// WEBPACK FOOTER //
// ./client/js/services/traveler.service.js